export default "__VITE_ASSET__BZEvf7JE__"